import { render, staticRenderFns } from "./ehc-properties-table.vue?vue&type=template&id=2ab86363"
import script from "./ehc-properties-table.vue?vue&type=script&lang=js"
export * from "./ehc-properties-table.vue?vue&type=script&lang=js"
import style0 from "./ehc-properties-table.vue?vue&type=style&index=0&id=2ab86363&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ehc-properties-table.vue?vue&type=custom&index=0&blockType=ehc-properties-table&%3Aproperties=propertiesFiltered&%40displayAsGrid=displayAs%20%3D%20%22gallery%22"
if (typeof block0 === 'function') block0(component)

export default component.exports